import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-form-section"
export default class extends Controller {
  static targets = ['dateBody', 'dateHeader', 
                    'extrasBody', 'extrasHeader',
                    'floorplansBody', 'floorplansHeader',
                    'formSection']

  connect() {
    if(this.formSectionTarget.value === 'date') {
      this.openDate()
    } else if(this.formSectionTarget.value === 'floorplans') {
      this.openFloorplans()
    } else if(this.formSectionTarget.value === 'extras') {
      this.open(this.extrasBodyTarget);
      this.close(this.extrasHeaderTarget);
    }
  }

  close(target){
    target.classList.add('closed');
    target.classList.remove('open');
  }

  closeDate(){
    this.close(this.dateBodyTarget);
    this.open(this.dateHeaderTarget);
  }

  closeFloorplans(){
    this.close(this.floorplansBodyTarget);
    this.open(this.floorplansHeaderTarget);
  }

  confirmFloorplans(){
    if(this.formSectionTarget.value = 'floorplans') {
      this.formSectionTarget.value = 'extras';
    }
    this.closeFloorplans();
  }

  confirmDate(){
    if(this.formSectionTarget.value === 'date') {
      this.formSectionTarget.value = 'floorplans';
    }
    this.closeDate();
  }

  confirmExtras(){
    if(this.formSectionTarget.value === 'extras') {
      this.formSectionTarget.value = '';
    }
    this.close(this.extrasBodyTarget);
    this.open(this.extrasHeaderTarget);
  }

  keepExtras(){
    this.formSectionTarget.value = 'extras';
  }

  open(target){
    target.classList.add('open');
    target.classList.remove('closed');
  }

  openDate(){
    this.open(this.dateBodyTarget);
    this.close(this.dateHeaderTarget);
  }

  openFloorplans(){
    this.formSectionTarget.value = 'floorplans';
    this.closeDate();
    this.open(this.floorplansBodyTarget);
    this.close(this.floorplansHeaderTarget);
  }
}
